import { render, staticRenderFns } from "./help-center.page.vue?vue&type=template&id=04b8724a"
import script from "./help-center.page.vue?vue&type=script&lang=js"
export * from "./help-center.page.vue?vue&type=script&lang=js"
import style0 from "./help-center.page.vue?vue&type=style&index=0&id=04b8724a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports